import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useSession } from '@/lib/auth'
import SessionUnknown from '@/components/auth/SessionUnknown'
import { useCanManagePersonnel } from '@/lib/acl'

/**
 * Wrapper który przepuszcza ADMIN + Manager + Księgowa.
 * Source of truth żyje w packages/shared/src/acl.ts (canManagePersonnel).
 * Backend `requireManagePersonnel` (alias requireReportAccess) blokuje API
 * niezależnie — ten wrapper tylko zapobiega wejściu do widoku.
 *
 * Nazwa `RequireReportAccess` zachowana z M6a v2 jako alias; przyszły refactor
 * może przemianować na RequireManagePersonnel.
 */
export default function RequireReportAccess() {
  const session = useSession()
  const location = useLocation()
  const canManage = useCanManagePersonnel()

  const user = session.data
  // Jak w RequireAuth: /login tylko po 401 (data === null). Push z linkiem do
  // /admin/day/… otwarty bez zasięgu ma pokazać „brak połączenia", nie logowanie.
  if (user === undefined) return <SessionUnknown />
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />
  }
  if (!canManage) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
